import { useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import { Sidebar, Topbar } from './components';

const Main = ({ children }) => {
  const [openSidebar, setOpenSidebar] = useState(false);

  const handleSidebarOpen = () => {
    setOpenSidebar(true);
  };

  const handleSidebarClose = () => {
    setOpenSidebar(false);
  };

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        bgcolor: '#FAFAFA',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}>
      {/* Fixed application header */}
      <Box
        sx={{
          flexShrink: 0,
          position: 'relative',
          zIndex: theme => theme.zIndex.appBar
        }}>
        <Topbar onSidebarOpen={handleSidebarOpen} />
      </Box>

      <Sidebar
        open={openSidebar}
        onClose={handleSidebarClose}
        variant="temporary"
      />

      {/* Remaining page area */}
      <Box
        component="main"
        sx={{
          flex: 1,
          minHeight: 0,
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden'
        }}>
        {children}
      </Box>
    </Box>
  );
};

Main.propTypes = {
  children: PropTypes.node
};

export default Main;